import React from 'react';

import { Button } from 'hosman-material';
import { SPONSORSHIP_MAX_BONUS, EXTERNAL_SPONSORSHIP_URL } from '../../../../../../../../../shared/helpers/sponsorshipHelper';
import SponsorshipBonusesTable from '../../../../../../../components/Marketing/components/SponsorshipBonusesTable';

const SponsorshipCard = () => {
  return (
    <a href={`${EXTERNAL_SPONSORSHIP_URL}?utm_source=site_hosman&utm_medium=successpage&utm_campaign=parrainage`} target='_blank'>
      <div className='flex flex-col gap-8 text-ih-indigo border-2 border-ih-purple-20 hover:border-ih-purple-40 bg-hosman-gradient-1 rounded-3xl px-4 py-10 md:px-7 md:py-14' data-testid='SponsorshipCard'>
        <div className='text-xl font-bold text-ih-indigo text-center'>
          <p>Envie de gagner jusqu'à {SPONSORSHIP_MAX_BONUS.toLocaleString('fr-FR')}€ ?</p>
          <p>Parrainez un proche !</p>
        </div>

        <div className='flex flex-wrap gap-3 justify-center'>
          <div className='flex flex-col items-center gap-3 border border-ih-blue-70 rounded-2xl bg-white p-3'>
            <p className='font-medium'>Acte authentique</p>

            <SponsorshipBonusesTable />
          </div>
        </div>

        <div className='md:w-max mx-auto'>
          <Button label="Découvrez l'offre de parrainage" />
        </div>
      </div>
    </a>
  );
}

export default SponsorshipCard;
